import Konva from 'konva'

class Circle extends Konva.Circle {
  constructor (attrs) {
    const defaults = {
      stroke: 'black',
      strokeEnabled: true,
      strokeWidth: 1,
      fill: 'white',
      fillEnabled: true,
      visible: true,
      opacity: 1
    }
    super(Object.assign({}, defaults, attrs))
  }
}

class Rect extends Konva.Rect {
  constructor (attrs) {
    const defaults = {
      stroke: 'black',
      strokeEnabled: true,
      strokeWidth: 1,
      fill: 'white',
      fillEnabled: true,
      visible: true,
      opacity: 1
    }
    super(Object.assign({}, defaults, attrs))
  }
}

class Line extends Konva.Line {
  constructor (attrs) {
    const defaults = {
      stroke: 'black',
      strokeEnabled: true,
      strokeWidth: 5,
      lineCap: 'butt',
      visible: true,
      closed: false,
      opacity: 1
    }
    super(Object.assign({}, defaults, attrs))
  }
}

export default { Circle, Rect, Line }
